import { ApiError } from './api'

/**
 * Texts for entering a colleague's invitation code (mobile web profile and referral sheet). One
 * place, so both screens say the same thing and follow the current rules: the inviter's first bonus
 * comes when the invitee finishes their first trip (with a real track), and only a new manager —
 * before their first paid tariff and first finished trip — can enter a code at all.
 */
export const REFERRAL_CLAIMED_TEXT = 'Код применён. Коллега получит бонус, когда вы завершите первую заявку.'
export const REFERRAL_ALREADY_LINKED_TEXT = 'Вы уже привязаны к пригласившему коллеге.'
export const REFERRAL_CLAIM_HINT = 'Код можно ввести один раз — до первой оплаты тарифа и первой завершённой заявки.'
export const REFERRAL_LINKED_NOTE = 'Вы пришли по приглашению коллеги.'

/** Refusals the server explains itself — its message is written for the user and shown as is. */
const EXPLAINED_REFUSALS = new Set(['REFERRAL_NOT_NEW', 'REFERRAL_MUTUAL'])

export function referralClaimErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    if (EXPLAINED_REFUSALS.has(error.code) && error.message) return error.message
    if (error.status === 404) return 'Такой код не найден. Проверьте его и попробуйте снова.'
    if (error.status === 400) return 'Этот код нельзя применить к вашему аккаунту.'
  }
  return 'Не удалось применить код. Попробуйте ещё раз.'
}
